import { render } from "./console.vue?vue&type=template&id=67d1e0f7&scoped=true"
import script from "./console.vue?vue&type=script&lang=js"
export * from "./console.vue?vue&type=script&lang=js"

import "./console.vue?vue&type=style&index=0&id=67d1e0f7&lang=less"
import "./console.vue?vue&type=style&index=1&id=67d1e0f7&scoped=true&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d1e0f7"]])

export default __exports__